'use client';

import { useEffect } from 'react';
import { useParams, useSearchParams } from 'next/navigation';

import { getModuleByPlan } from '../lib/parsers';
import { generateModuleTOC } from '../lib/toc';
import { useModuleStore } from '../model/store';

export const useActiveModule = () => {
  const { moduleId } = useParams<{ moduleId: string }>();
  const moduleParam = useSearchParams().get('module');

  const modulesByPlan = useModuleStore((state) => state.modulesByPlan);
  const activePlanId = useModuleStore((state) => state.plan);
  const plans = useModuleStore((state) => state.plans);
  const setModule = useModuleStore((state) => state.setModule);
  const setTOC = useModuleStore((state) => state.setTOC);

  useEffect(() => {
    const activeModule =
      getModuleByPlan(moduleId || moduleParam || '', activePlanId || '', modulesByPlan) ||
      plans.find((m) => m.id === moduleId || m.id === moduleParam);
    const toc = activeModule ? generateModuleTOC(activeModule) : [];

    setModule(activeModule);
    setTOC(toc);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [moduleId, moduleParam, modulesByPlan, activePlanId]);
};
